import logoSutd from "@assets/events-awards/dta/logo-sutd.jpg";
import logoBT from "@assets/logo-masthead.svg";
import Container from "@components/Container/Container";

/**
 * Component to render Organiser Details of DTA on homepage
 */
const DTAOrganiserDetails = (): React.ReactElement => {
  return (
    <Container
      rootClassName="font-public-sans text-gray-850"
      data-testis="dta-organiser-details-component"
    >
      <p className="pt-3 text-center">Jointly organised by</p>

      <div className="flex flex-col items-center justify-center px-3 pb-18 pt-2 md:flex-row md:px-6 lg:px-12">
        <img
          src={logoBT}
          width={211}
          height={21}
          alt="The Business Times logo"
          className="my-4 mb-8 ml-10 md:my-0 md:ml-0 md:mr-16"
        />

        <img
          src={logoSutd}
          width={141}
          height={54}
          alt="SUTD logo"
          className="my-4 md:ml-16"
        />
      </div>
    </Container>
  );
};

export default DTAOrganiserDetails;
